import api from './api';

export const qaService = {
  getByListing: async (listingId) => {
    const res = await api.get(`/QA/GetByListing/${listingId}`);
    return res.data.data;
  },

  ask: async (listingId, questionText) => {
    const res = await api.post('/QA/Ask', { listingId, questionText });
    return res.data.data;
  },

  answer: async (questionId, answerText) => {
    const res = await api.post('/QA/Answer', { questionId, answerText });
    return res.data.data;
  },
};
